module.exports = BD.Model.extend({
    organization: BD.belongsTo('Billy.Organization'),
    user: BD.belongsTo('Billy.User', { readonly: true }),
    name: BD.attr('string'),
    description: BD.attr('string'),
    accessTokens: BD.hasMany('Billy.OAuthAccessToken', 'actor')
})
